import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa0ad156"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "max-w-5xl mx-auto" };
const _hoisted_2 = { class: "button-row" };
const _hoisted_3 = { class: "panel" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "クーポン詳細", -1));
const _hoisted_5 = {
    key: 0,
    class: "pointinfo-wrapper"
};
const _hoisted_6 = { class: "panel" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "一括付与操作履歴", -1));
const _hoisted_8 = { class: "table-wrapper" };
const _hoisted_9 = { class: "result-table" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "operation_date" }, "付与日時"),
        /*#__PURE__*/ _createElementVNode("th", { class: "store" }, "付与店舗"),
        /*#__PURE__*/ _createElementVNode("th", { class: "operator" }, "付与者"),
        /*#__PURE__*/ _createElementVNode("th", { class: "grant_number" }, "付与対象者")
    ])
], -1));
const _hoisted_11 = { class: "operation_date" };
const _hoisted_12 = { class: "store" };
const _hoisted_13 = { class: "operator" };
const _hoisted_14 = { class: "grant_number" };
const _hoisted_15 = { class: "panel" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "付与対象者一覧", -1));
const _hoisted_17 = { class: "table-wrapper" };
const _hoisted_18 = { class: "result-table" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "crm_customer_id" }, "顧客ID"),
        /*#__PURE__*/ _createElementVNode("th", { class: "user_name" }, "氏名"),
        /*#__PURE__*/ _createElementVNode("th", { class: "mobile_phone_number" }, "電話番号"),
        /*#__PURE__*/ _createElementVNode("th", { class: "grant_type_detail" }, "付与種別"),
        /*#__PURE__*/ _createElementVNode("th", { class: "history_date" }, "付与日時")
    ])
], -1));
const _hoisted_20 = { class: "crm_customer_id" };
const _hoisted_21 = { class: "user_name" };
const _hoisted_22 = { class: "mobile_phone_number" };
const _hoisted_23 = { class: "grant_type_detail" };
const _hoisted_24 = { class: "history_date" };
const _hoisted_25 = { class: "table-footer" };
const _hoisted_26 = ["disabled"];
const _hoisted_27 = { class: "page-indicator" };
const _hoisted_28 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_ModalQrCode = _resolveComponent("ModalQrCode");
    const _component_CouponInfo = _resolveComponent("CouponInfo");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Title, {
            msg: "クーポン付与結果",
            submsg: "Coupon Grant Result"
        }),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => ($options.openModal && $options.openModal(...args)))
            }, "クーポンQR表示"),
            _createVNode(_component_ModalQrCode, {
                type: $data.type,
                id: $data.couponBulkOperationHistoryId,
                name: $data.name,
                value: $data.value,
                visible: $data.show,
                onClose: $options.closeModal
            }, null, 8, ["type", "id", "name", "value", "visible", "onClose"])
        ]),
        _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            ($data.couponCode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_CouponInfo, { coupon_code: $data.couponCode }, null, 8, ["coupon_code"])
                ]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_11, _toDisplayString($options.formatDatetime($data.sCBResult.operation_date)), 1),
                            _createElementVNode("td", _hoisted_12, _toDisplayString($data.sCBResult.store), 1),
                            _createElementVNode("td", _hoisted_13, _toDisplayString($data.sCBResult.operator), 1),
                            _createElementVNode("td", _hoisted_14, _toDisplayString($data.sCBResult.grant_number), 1)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("table", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pagedInfo, (r, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                _createElementVNode("td", _hoisted_20, _toDisplayString(r.crm_customer_id), 1),
                                _createElementVNode("td", _hoisted_21, _toDisplayString(r.user_name), 1),
                                _createElementVNode("td", _hoisted_22, _toDisplayString(r.mobile_phone_number), 1),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(r.grant_type_detail === "0" ? "一括付与" : "QR"), 1),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(r.history_date), 1)
                            ]));
                        }), 128))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                    class: "pg-btn",
                    disabled: $data.infoPage <= 1,
                    onClick: _cache[1] || (_cache[1] = ($event) => ($options.setInfoPage($data.infoPage - 1)))
                }, " ‹ ", 8, _hoisted_26),
                _createElementVNode("div", _hoisted_27, _toDisplayString($data.infoPage) + " / " + _toDisplayString($options.infoTotalPages), 1),
                _createElementVNode("button", {
                    class: "pg-btn",
                    disabled: $data.infoPage >= $options.infoTotalPages,
                    onClick: _cache[2] || (_cache[2] = ($event) => ($options.setInfoPage($data.infoPage + 1)))
                }, " › ", 8, _hoisted_28)
            ])
        ])
    ]));
}
